import { CANTRATE_ID } from '@webapp/common/resources/constants';

import { excludeHiddenAnswers } from '@webapp/survey/src/machine/helpers/logic';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

const checkValue = (val: any) => (typeof val === 'number' ? true : Boolean(val));

export class CsiApi extends QuestionSimpleApi {
    // TODO: correct matching @didolf
    public query(actor: QuestionActor): AnswersRequest {
        const { groupsActors, id, answersActors, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        const groupWithOrderOne = groupsActors[0]?.getSnapshot().context;
        const groupWithOrderTwo = groupsActors[1]?.getSnapshot().context;

        return {
            comment,
            question: id,
            data: excludeHiddenAnswers(answersActors).flatMap((answerActor) => {
                const { id: answerId, response } = answerActor.getSnapshot().context;
                const { value: score, extra: importance, comment } = response.getSnapshot().context;

                if (score === CANTRATE_ID) {
                    return [
                        {
                            answer: answerId,
                            bool: true,
                            comment: null,
                            cantRate: true,
                        },
                    ];
                }

                return [
                    {
                        group: groupWithOrderOne?.id,
                        bool: true,
                        answer: answerId,
                        int: score as number,
                        comment,
                        cantRate: undefined,
                    },
                    {
                        group: groupWithOrderTwo?.id,
                        bool: true,
                        answer: answerId,
                        int: importance as number,
                        comment,
                        cantRate: undefined,
                    },
                ];
            }),
        };
    }

    public validate({
        answersActors: answersActorsRaw,
        params: { required, commentRequired },
    }: QuestionContext): boolean {
        if (required) {
            const answersActors = excludeHiddenAnswers(answersActorsRaw);
            answersActors.forEach((answerActor) => {
                const a = answerActor.getSnapshot().context;
                const response = a.response.getSnapshot().context;
                const valid =
                    checkValue(response.value) &&
                    checkValue(response.extra) &&
                    (commentRequired ? checkValue(response.comment) : true);
                answerActor.send({ type: 'SET_VALID', value: valid });
            });

            return answersActors.every((answerActor) => {
                const { response } = answerActor.getSnapshot().context;
                const { value, extra, comment } = response.getSnapshot().context;
                return value === CANTRATE_ID
                    ? true
                    : checkValue(value) && checkValue(extra) && (commentRequired ? checkValue(comment) : true);
            });
        }

        return true;
    }
}
